import React, { useState, useEffect } from "react";
import { db } from "../../firebaseConfig";
import { collection, updateDoc, doc } from "firebase/firestore";

function EditAnnounce(props) {
  const activeNews = props.activeNews;
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    console.log(activeNews);
    setId(activeNews.id);
    setTitle(activeNews.title);
    setDate(activeNews.date);
  }, []);

  const updateNews = async (id) => {
    const newsDoc = doc(db, "announcements", id);
    const newsInputs = {
      title: title,
      date: date,
    };
    await updateDoc(newsDoc, newsInputs);
    alert("News Updated");
    props.refreshNews();
    props.closeForm();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="fixed inset-0 bg-slate-800/40"
        onClick={props.closeForm}
      ></div>
      <div className="relative z-10 w-full max-w-sm bg-white rounded-2xl shadow-2xl flex flex-col">
        <div className="flex justify-between items-center px-5 py-4 border-b">
          <h2 className="text-base font-bold text-slate-800">Edit Announcement</h2>
          <button
            className="text-slate-400 hover:text-slate-700 text-2xl leading-none cursor-pointer"
            onClick={props.closeForm}
          >
            &times;
          </button>
        </div>
        <div className="px-5 py-4 flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-slate-700">Title <span className="text-rose-500">*</span></label>
            <input
              className="border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-slate-700">Date <span className="text-rose-500">*</span></label>
            <input
              className="border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
        </div>
        <div className="px-5 py-4 border-t flex justify-end gap-3">
          <button
            className="px-4 h-9 rounded-lg border border-slate-300 text-slate-700 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
            onClick={props.closeForm}
          >
            Cancel
          </button>
          <button
            className="px-4 h-9 rounded-lg bg-sky-600 text-white text-sm font-semibold hover:bg-sky-700 cursor-pointer"
            onClick={() => updateNews(activeNews.id)}
          >
            Update Announcement
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditAnnounce;
